import { RETAIL_PATH } from '../root'

const HISTORY_PAYMENTS = 'history-transfers'
const INCOMING_PAYMENTS = 'incoming-transfers'
const HISTORY_PAYMENTS_FULL_PATH = `${RETAIL_PATH}/${HISTORY_PAYMENTS}`

export { HISTORY_PAYMENTS, INCOMING_PAYMENTS, HISTORY_PAYMENTS_FULL_PATH }
